import axios from "axios";
export const api = axios.create({
  baseURL: process.env.VUE_APP_API_ROOT_URL,

  headers: {
    //"Content-Type": "application/json",
    "Content-Type": "multipart/form-data",
    Accept: "application/json, text/plain, */*",
    //"Access-Control-Allow-Origin": "*",
    //Authorization: `Bearer ${JSON.parse(localStorage.getItem("user"))?.token}`,
  },
});

api.interceptors.request.use((config) => {
  const user = localStorage.getItem("user");
  if (user) {
    const token = JSON.parse(user).token;
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
